import React, { useEffect, useState,useRef } from "react";
import { Link, Navigate } from "react-router-dom";
import MyCareerLogo from "../../images/svg/mc-logo.svg";
import MyConnectLogo from "../../images/svg/myconnect_logo.svg";
import { userDataState,logoutDrpdown } from "../../atoms/dashboard";
import { useRecoilValue, useResetRecoilState,useRecoilState } from "recoil";
import { myCareerWheel } from "../../selectors/dashboard";
import { MycarUrl } from "../../selectors/baseurl";
const Header = (props) => {
  const userData = useRecoilValue(userDataState);
  const resetAuth1 = useResetRecoilState(userDataState);
  const careerWheelApiData = useRecoilValue(myCareerWheel);
  const dropDownRef =useRef(null)
  //const [isDropdownOpen, setDropdownOpen] = useRecoilState(logoutDrpdown);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
 if (userData?.isLogged == false) window.location.href = MycarUrl;
  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };
  function nameSerial() {
    // let name = userData?.employeeName;
    // let fname = name?.split(" ");
    // let splname = fname[0][0] + fname[1][0];
    let extracss=careerWheelApiData?.length > 0 && careerWheelApiData !='No record found' ? "marginRight:10px; minWidth:40px; minHeight:auto;":"";
    let splname =
      "https://myconnect-pages.rrd.com/IconnectReader/iConnectUploadData/EMPPhotoNew/" +
      userData.empID +
      ".jpg";
    return <img src={splname} className="h-10 w-10 rounded-full avatar-img noavtarimg"/>;
  }
  
  useEffect(() => {
    const checkIfClickedOutside = e => {   
      if (isDropdownOpen && dropDownRef.current && !dropDownRef.current.contains(e.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener("mousedown", checkIfClickedOutside)

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [isDropdownOpen])
  useEffect(() => {
    let moreIcon = document.getElementById("more-icon");
    if (moreIcon !== null) {
      moreIcon.onclick = (e) => {
        let dropdown = document.querySelectorAll(".dropdown");
        for (let i = 0; i < dropdown.length; ++i) {
          dropdown[i].classList.add("hidden");
        }
        document.getElementById("more-dropdown")?.classList.toggle("hidden");
      };
    }

    let accIcon = document.getElementById("acc-icon");
    if (accIcon !== null) {
      accIcon.onclick = (e) => {
        let dropdown = document.querySelectorAll(".dropdown");
        for (let i = 0; i < dropdown.length; ++i) {
          dropdown[i].classList.add("hidden");
        }
        document.getElementById("acc-dropdown").classList.toggle("hidden");
      };
    }

    document.addEventListener("click", function(event) {
      if (
        !event.target.closest("#more-dropdown") &&
        !event.target.closest("#more-icon")
      ) {
        let menuDropdownContainer = document.getElementById("more-dropdown");
        console.log(menuDropdownContainer);
        if (menuDropdownContainer) {
          menuDropdownContainer.classList.add("hidden");
        }
      }

      if (
        !event.target.closest("#acc-dropdown") &&
        !event.target.closest("#acc-icon")
      ) {
        let accDropdownContainer = document.getElementById("acc-dropdown");
        console.log(accDropdownContainer);
        if (accDropdownContainer) {
          accDropdownContainer.classList.add("hidden");
        }
      }
    });
  }, []);

  return (
    <header className="h-[50px]  px-7 flex flex-row relative justify-between border-b border-proj-input-border-gray z-10">
      <div className="flex flex-row items-center">
        <div className="flex flex-row justify-center items-center h-7 border-r border-[#9ca3af] md:pr-4">
          {" "}
          <a onClick={resetAuth1}>
            <img
              src={MyConnectLogo}
              alt="myconnect logo"
              className="cursor-pointer w-full"
            />
          </a>
        </div>
        <div className="flex flex-row justify-center items-center px-3">
          <h1>
            <Link to="/dashboard">
              <img src={MyCareerLogo} />
            </Link>
          </h1>
        </div>
      </div>
      <div className="flex flex-row items-center gap-2">
        <div className="relative header-main">
          <div className="menu-dropdown-container absolute top-[50px] -right-40 md:right-0 transition-[opacity,margin] duration-[0.1ms] sm:duration-[150ms] sm:w-48 z-20 bg-white sm:shadow-md rounded-lg p-2 sm:border !w-[20rem] border-0 border-[#f5f5f5] hidden">
            <div className="p-4">
              <div className="grid grid-cols-3 gap-x-4 gap-y-4 max-h-80 pr-2 overflow-x-hidden overflow-y-auto">
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Employee Central</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Workforce Management</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Work Life</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Capacity Planner</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Cell Management</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Help</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Talent Management</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Explore</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Explore</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Cell Management</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Help</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Talent Management</p>
                  </div>
                </div>
                <div className="group menu-dropdown cursor-pointer flex flex-col justify-center items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-9"
                  >
                    <path
                      stroke="#0066FF"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                    ></path>
                  </svg>
                  <div className="text-xs text-[#282b2f] font-medium group-hover:text-[#0069e2] group-focus:text-[#0069e2]">
                    <p className="text-center">Explore</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div onClick={() => props.onBtnClick()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
            />
          </svg>
        </div> */}
        {/* <div className="dropdown-container">
          <div className="dropdown profile relative hs-dropdown [--adaptive:none] [--placement:bottom-right]">
            <button
              type="button"
              id="menu-button"
              aria-expanded="true"
              aria-haspopup="true"
              onClick={toggleDropdown}
            >
              <img
                class="h-8 w-8 rounded-full avatar-img"
                src="https://myconnect-pages.rrd.com/IconnectReader/iConnectUploadData/EMPPhotoNew/30178.JPG"
                alt="Avatar Image"
              ></img>
            </button>
            {isDropdownOpen && console.log("dropdown appeared")}
          </div>
        </div> */}
        <div className="dropdown-container">
          <div className="profile relative hs-dropdown [--adaptive:none] [--placement:bottom-right]">
            <button
              type="button"
              id="menu-button"
              aria-expanded={isDropdownOpen ? "true" : "false"}
              aria-haspopup="true"
              onClick={toggleDropdown}
              // className="focus:outline-none"
            >
              {nameSerial()}
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 z-10 mt-2 w-[18rem] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-4" ref={dropDownRef}>
                <div className="flex space-x-4 pb-2 items-center border-b-2 border-gray-300">
                  <div>
                  {nameSerial()}
                  </div>
                  <div className="ovrflow">
                    <div className="text-[14px] font-medium text-[#033d9b] w-auto wrdwrpnm">
                      {userData.employeeName}
                    </div>
                    <div className="text-[12px] text-gray-500 wrdwrp">
                      {userData.emailID}
                    </div>
                  </div>
                </div>
                <div
                  className="pt-2 text-md cursor-pointer"
                  onClick={
                    (location.pathname !== "/journey-map" &&  location.pathname !== "/help")
                      ? () => {setDropdownOpen(false) ; props.onBtnClick()}
                      : null
                  }
                >
                  Coachmark
                </div>
                <div
                  className="pt-2 text-md cursor-pointer"
                >
                  <Link to='/help'>Help</Link>
                </div>
                <div
                  className="pt-2 text-md cursor-pointer"
                  onClick={resetAuth1}
                >
                  Back to Myconnect
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
